module.exports = __webpack_public_path__ + "img/light.848b9362.png";